import React from 'react';
import PropTypes from "prop-types";
import MaterialSpinner from "./materialSpinner";
import {IS_LIXIL_UI} from "../../config";

const LoadingSpinner = (props) => {
  if (IS_LIXIL_UI) {
    return <MaterialSpinner/>
  }
  const size = props.size || "small"; //class modifier
  return <div style={props.style || null}
              className={"message-loading-left-panel-spinner message-loading-left-panel-spinner--" + size}/>
};

LoadingSpinner.propTypes = {
  size: PropTypes.string
}

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
